import React, { useEffect } from "react";
import ReactDOM from "react-dom";

/**
 * Capa a pantalla completa (modales y panel de búsqueda).
 *
 * Va en un portal a `body` a propósito: el header tiene `backdrop-blur`, y un
 * ancestro con filtro se vuelve el bloque contenedor de sus descendientes
 * `fixed`, así que un modal renderizado adentro del header quedaba pegado al
 * header en vez de cubrir la pantalla.
 *
 * Además bloquea el scroll de fondo y cierra con Escape o clic afuera.
 */
const Overlay = ({ onClose, label, children }) => {

	useEffect(() => {
		const handleKeyDown = (event) => {
			if (event.key === "Escape") onClose();
		};

		document.addEventListener("keydown", handleKeyDown);
		document.body.classList.add("overlay-open");

		return () => {
			document.removeEventListener("keydown", handleKeyDown);
			document.body.classList.remove("overlay-open");
		};
	}, [onClose]);

	if (typeof document === "undefined") return null;

	const onBackdropClick = (event) => {
		if (event.target === event.currentTarget) onClose();
	};

	return ReactDOM.createPortal(
		<div
			onMouseDown={ onBackdropClick }
			className="fixed inset-0 z-[110] flex items-start justify-center overflow-y-auto bg-[rgba(5,14,31,.76)] px-4 py-10 backdrop-blur-sm sm:items-center"
			role="dialog"
			aria-modal="true"
			aria-label={ label }
		>
			{ children }
		</div>,
		document.body
	);
};

export default Overlay;
